"use client";

import { Suspense, useMemo } from "react";
import { PropertyDataV2 } from "commonModule/services/common";
import FavoriteButtonForPropertyPopOverVersion from "components/favorite-button/FavoriteButtonForPropertyPopOverVersion";
import NewHeartFavIcon from "components/icons-svg/NewHeartFavIcon";
import useFavorites from "hooks/swr/useFavorites";
const FavoriteButtonWrapper = ({
  property,
  isListingPage,
  setIsCloseOnOutsideEnabled
}: {
  property: PropertyDataV2;
  isListingPage?: boolean;
  setIsCloseOnOutsideEnabled?: (value: boolean) => void;
}) => {
  const favPropertyIds = useFavorites();
  const isFavourite = useMemo(() => {
    return !!favPropertyIds.find(id => id === property._id);
  }, [favPropertyIds, property._id]);
  return <Suspense data-sentry-element="Suspense" data-sentry-component="FavoriteButtonWrapper" data-sentry-source-file="FavoriteButtonWrapper.tsx">
      <FavoriteButtonForPropertyPopOverVersion isFavorited={isFavourite} propertyId={property._id} propertyName={property.propertyName} city={property.city} state={property.state} country={property.country} numberOfBedroom={property.noOfBedroom} propertyTypeDesc={property.propertyTypeDesc} callbackWhenTriggeredWithoutLogin={() => {
      if (isListingPage) {
        localStorage.setItem("mixpanelPageOrigin", "Search Results Page - Save to Favorite");
      }
    }} property={property} loaderDotsHeight={10} loaderDotsWidth={10} setIsCloseOnOutsideEnabled={setIsCloseOnOutsideEnabled} data-sentry-element="FavoriteButtonForPropertyPopOverVersion" data-sentry-source-file="FavoriteButtonWrapper.tsx">
        {({
        className,
        onClick,
        role
      }) => <button onClick={e => {
        if (onClick) onClick(e);
        if (setIsCloseOnOutsideEnabled) setIsCloseOnOutsideEnabled(false);
      }} role={role} aria-label='save to favorite' className={`m-0 flex h-[18px] w-[18px] min-w-0 items-center justify-center px-0 ${className || ""}`}>
            <NewHeartFavIcon className={`h-[18px] w-[18px] stroke-primary-500 hover:text-accent-500 ${isFavourite ? "text-accent-500" : "text-white"}`} />
          </button>}
      </FavoriteButtonForPropertyPopOverVersion>
    </Suspense>;
};
export default FavoriteButtonWrapper;